/* -------------------------------------------------------------------------- */
/*                                   Common                                   */
/* -------------------------------------------------------------------------- */

export const NOT_APPLICABLE = 'N/A';

export const LINKEDIN_URL =
	'https://www.linkedin.com/company';

export const X_URL = 'https://www.x.com';

export const STAGING = 'Staging';

export const LOCAL = 'Local';

export const DEMO = 'Demo';

export const DEVELOP = 'Develop';
